import { NgModule } from '@angular/core';
import { MsMenuComponent } from './ms-menu.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';
import { MsButtonModule } from '../ms-button/ms-button.module';

@NgModule({
	declarations: [MsMenuComponent],
	imports: [SharedLibsModule, MsButtonModule],
	exports: [MsMenuComponent],
	providers: [],
})
export class MsMenuModule {}
